export const API_ERROR_MESSAGE: Record<number, string> = {
  401: 'Your current session has expired. Please log in again.',
  403: "You don't have the correct permissions to view parts of this page",
  404: 'Not found. Please try again.',
  500: 'Something went wrong. Please try again later.'
};
